export enum PendingTransactionStatus {
    Pending = 0,
    Successful = 1,
    Failed = 2,
}

